import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-departments-page',
  templateUrl: './departments-page.component.html',
  styleUrls: ['./departments-page.component.css'],
  host:{'[attr.id]': '\'content\''}
})
export class DepartmentsPageComponent implements OnInit {

  activeTab = 0;

  constructor() { }

  ngOnInit() {
  }

}
